import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTS } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class EntitiesService {
  headers = new HttpHeaders();
  country: string;

  constructor(private readonly http: HttpClient) { }

  /**
   * obtiene las entidades
   * @param token: string
   */
  getEntities(token): Observable<any> {
    //return of({banks: []});
    this.country = sessionStorage.getItem('country') || 'ES';
    return this.http.get<any>(environment.url + '/banks/GetBanksCountry?country=' + this.country, { headers: this.headers.set('Authorization', token) })
       .pipe(retry(1), catchError(this.errorHandl));
  }

  getTinkToken(id) {
    return this.http.get<any>(environment.url + '/Tink/GetToken', { params: {idtinkpetition: id} })
    .pipe(retry(1), catchError(this.errorHandl));
  }

  getTink(token = '') {
    return this.http.get<any>(environment.url + '/Tink/Link', { headers: this.headers.set('Authorization', token) })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getBankLink(token = '', CodeBank = '', Country = '') {
    const body = {
      CodeBank: CodeBank,
      Country: Country
    };
    return this.http.post<any>(environment.url + '/Banks/Link', body, { headers: this.headers.set('Authorization', token) })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getTinkResponse(data) {
    return this.http.post<any>(environment.url + '/Tink/Aggregation',
      {
        'account_verification_report_id': data['account_verification_report_id'],
        'transaction_report_id': data['transaction_report_id'],
      },
      { headers: this.headers.set('Authorization', data.request) })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getTinkRapidScore(data) {
    return this.http.post<any>(environment.url + '/OB/Aggregation',
      {
        'account_verification_report_id': data['account_verification_report_id'],
        'transaction_report_id': data['transaction_report_id'],
      },
      { headers: this.headers.set('Authorization', data.request) })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  postTinkError(data, token) {
    return this.http.post<any>(environment.url + '/Tink/Error',
    data,
    { headers: this.headers.set('Authorization', token) })
    .pipe(retry(1), catchError(this.errorHandl));
  }

  /**
   * conecta con la entidad bancaria
   * @param token: string
   */
  connectToEntity(data, channel?): Observable<any> {
    const request = {
      BankCode: data.BankCode,
      credentials: data.credentials,
    };
    let url;
    if (CONSTANTS.getChannels(channel)) {
      url = '/OB/Aggregation';
    } else {
      url = '/Tink/Aggregation';
    }
    return this.http.post<any>(environment.url + url, request, { headers: this.headers.set('Authorization', data.token) })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * conecta con la entidad bancaria y realiza SCA
   * @param data: object
   */
  connectToEntitySCA(data: any) {
    let url;

    if (CONSTANTS.getChannels(data.channel)) {
      url = '/OB/SCA';
    } else {
      url = '/EB/SCA';
    }

    return this.http.post<any>(environment.url +
      url, data, { headers: this.headers.set('Authorization', sessionStorage.getItem('t')) })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * Control errores generico para todas las llamadas
   * @param error: Object
   */
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
